/**
 * 16:9 aspect ratio
 */
export const presentationDimensions = {
	w: 10,
	h: 5.625
};

export const defaultViewPortPadding = {
	vertical: 0.3,
	horizontal: 0.5
};

export const colors = {
	blue: '213857',
	yellow: 'F7D107',
	gray: 'EAEAEA',
	white: 'FFFFFF',
	lightGray: 'F4F4F4',
	lightYellow: 'FFE882',
	bluePale: 'D3D7DD',
	defaultSeason: 'C5E0FF',
	lowSeason: 'C0F1A7',
	highSeason: 'EEB8DC'
};

export const spacing = {
	small: 8,
	default: 12,
	large: 16
};

export const elementSizes = {
	badgeHeight: 0.3,
	footnoteHeight: 0.45,
	metaHeaderHeight: 0.45,
	seasonCalendarHeight: 0.3,
	paginationHeight: 0.3
};
